if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // adding product options
        const hasProductOptions =
          document.querySelector(".product .product-options")?.childElementCount > 0 &&
          document.querySelector(".product .product-options input:checked");
        if (hasProductOptions) {
          const productOptions = document.querySelector(".product .product-options");
          const optionTitle = [];
          productOptions
            ?.querySelectorAll("input:not([name='product-variant-id']):not([name='product-variant-quantity'])")
            .forEach((input) => {
              const inputName = input.getAttribute("name");
              if (!optionTitle.includes(inputName)) {
                optionTitle.push(inputName);
              }
            });
          const addons = [];
          const optionId = [];
          optionTitle.forEach((option) => {
            console.log("option title", option);
            const values = [];
            productOptions.querySelectorAll(`input[name="${option}"]`).forEach((input) => {
              switch (input.type) {
                case "checkbox":
                case "radio": {
                  if (input.checked) {
                    values.push(input.getAttribute("value"));
                    const parent = input.parentNode;
                    const variantId = parent.querySelector('input[name="product-variant-id"]').value * 1;
                    const quantity = parent.querySelector('input[name="product-variant-quantity"]').value * 1;
                    addons.push({ id: variantId, quantity });
                  }
                  break;
                }
                default: {
                  break;
                }
              }
            });

            const optionName = values.join(", ");
            if (Boolean(optionName)) {
              optionId.push(optionName);
            }
            formData.append(option, optionName);
          });

          console.log("option id", formData.get("id") + "||" + optionId.join("|").split(" ").join("-").toLowerCase());
          addons.forEach((addon) => {
            addon.properties = {
              _product: formData.get("id") + "||" + optionId.join("|").split(" ").join("-").toLowerCase(),
            };
          });

          // addons.push({ id: formData.get("id") * 1, quantity: formData.get("quantity") * 1 });
          // const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : "";
          const newData = {
            items: [...addons],
          };

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(newData),
          })
            .then((response) => response.json())
            .then(() => {
              if (this.cart) {
                formData.append(
                  "sections",
                  this.cart.getSectionsToRender().map((section) => section.id)
                );
                formData.append("sections_url", window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
              }
              config.body = formData;

              fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: "product-form",
                      productVariantId: formData.get("id"),
                      errors: response.errors || response.description,
                      message: response.message,
                    });
                    this.handleErrorMessage(response.description);

                    const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute("aria-disabled", true);
                    this.submitButtonText.classList.add("hidden");
                    soldOutMessage.classList.remove("hidden");
                    this.error = true;
                    return;
                  } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }

                  if (!this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: "product-form",
                      productVariantId: formData.get("id"),
                      cartData: response,
                    });
                  this.error = false;
                  const quickAddModal = this.closest("quick-add-modal");
                  if (quickAddModal) {
                    document.body.addEventListener(
                      "modalClosed",
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(response);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    this.cart.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  this.submitButton.classList.remove("loading");
                  if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
                  if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                  this.querySelector(".loading__spinner").classList.add("hidden");
                });
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        } else {
          // productOptions?.querySelectorAll("input").forEach((input) => {
          //   if (input.checked) {
          //     formData.append(input.getAttribute("name"), input.getAttribute("value"));
          //   }
          // });
          // for (const pair of formData.entries()) {
          //   console.log(pair[0], pair[1]);
          // }
          // end adding product options

          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButtonText.classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
              if (!this.error) this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
